import { Box, BoxComponentProps } from '@dtx-company/shared-components/src'
import React from 'react'
import styled from 'styled-components'

export type ProgressBarProps = {
  percentage: number
} & BoxComponentProps

const StyledBox = styled(Box)`
  transition: width 0.25s ease-out;
`

export const ProgressBar = ({
  percentage,
  height = 10,
  ...rest
}: ProgressBarProps): JSX.Element => (
  <Box
    backgroundColor="secondary.backgroundDark"
    height={height}
    width="calc(100% - 32px)"
    overflow="hidden"
    margin="0px 16px"
    {...rest}
  >
    <StyledBox
      data-testid="progress-bar"
      width={percentage + '%'}
      backgroundColor="primary.flowBlue"
      height="100%"
    />
  </Box>
)
